const barbers = [
  {
    name: 'Mohammad',
    role: 'SENIOR BARBER',
    image: 'https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/13db9d4c3901117ae70c4af169ceb03e.png',
    bio: 'Mohammad is a senior barber with years of experience across all styles and techniques. From sharp skin fades and clean lineups to classic cuts and beard work, he delivers consistent, high-quality results every time — making sure every client walks out looking their best.',
  },
  {
    name: 'Zena',
    role: 'BARBER & HAIRDRESSER',
    image: 'https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/3c9cbbf5586ae5af8048d24672a1babf.png',
    bio: 'Zena is a skilled barber and hairdresser with a talent across all styles — fades, tapers, scissor cuts, and long hair. Whether it\'s a sharp barbershop finish or a full hairdressing service, she brings precision, care, and a great eye for detail to every client.',
  },
  {
    name: 'Abdy',
    role: 'SENIOR BARBER',
    image: 'https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/44a9666be59d7661d7d3283d825b79dc.jpeg',
    bio: 'Abdy is a senior barber who excels across the full range of barbering services. Known for clean fades, precise lineups, and polished beard work, he brings skill and consistency to every chair. Whatever the style, Abdy gets it done sharp and right every time.',
  },
];

export default function Barbers() {
  const handleBooking = () => {
    window.open('https://book.squareup.com/appointments/yc3ukarfxsbty9/location/LHRN4K68W4NE0', '_blank');
  };

  return (
    <section id="barbers" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">THE TEAM</div>
          <h2 className="text-6xl md:text-7xl font-bold text-black mb-6">Master Barbers</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our team of skilled professionals brings years of experience, passion, and dedication to every cut. Meet the experts who will transform your look.
          </p>
        </div>

        {/* Barbers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {barbers.map((barber, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="relative overflow-hidden">
                <div className="w-full h-96">
                  <img
                    src={barber.image}
                    alt={`${barber.name} - ${barber.role} at Reborn Barbershop Heidelberg Heights`}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                  />
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-3xl font-bold text-black mb-2">{barber.name}</h3>
                <div className="text-red-600 text-sm tracking-widest font-semibold mb-4 whitespace-nowrap">{barber.role}</div>
                <p className="text-gray-600 leading-relaxed mb-6">{barber.bio}</p>
                <button
                  onClick={handleBooking}
                  className="w-full bg-red-600 text-white py-3 rounded-lg font-bold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  BOOK WITH {barber.name.toUpperCase()}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}